import { useInitialLoading } from '../hooks/useInitialLoading';
import React, { useState, useEffect, useCallback } from 'react';
import { getAuthHeaders } from '../utils/authHeaders';
import { API, Badge, tableStyle, thStyle, tdStyle, btnDanger, inputStyle } from './RpShared';

export default function RpTimedAccess() {
  const companyId = localStorage.getItem('selectedCompanyId');
  const [grants, setGrants] = useState([]);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const initialLoading = useInitialLoading(loading);

  const fetchGrants = useCallback(async () => {
    setLoading(true);
    try {
      const url = new URL(`${API}/companies/${companyId}/roles-permissions/timed-access`);
      if (status) url.searchParams.set('status', status);
      const res = await fetch(url, { headers: getAuthHeaders() });
      setGrants(await res.json());
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [companyId, status]);

  useEffect(() => { fetchGrants(); }, [fetchGrants]);

  const cancel = async (id) => {
    if (!window.confirm('Cancel this temporary grant?')) return;
    try {
      await fetch(`${API}/companies/${companyId}/roles-permissions/timed-access/${id}/cancel`, { method: 'POST', headers: getAuthHeaders() });
      fetchGrants();
    } catch (e) { console.error(e); }
  };

  if (initialLoading) return <div style={{ padding: 32, textAlign: 'center' }}>Loading...</div>;

  return (
    <div style={{ padding: '24px 32px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <h2 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 700, color: '#1a1a2e' }}>⏳ Timed Access & Temporary Permissions</h2>

      <div style={{ marginBottom: 12 }}>
        <select style={{ ...inputStyle, width: 220 }} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All statuses</option>
          <option value="scheduled">Scheduled</option>
          <option value="active">Active</option>
          <option value="expiring_soon">Expiring Soon</option>
          <option value="expired">Expired</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </div>

      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 18 }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Scope</th>
                <th style={thStyle}>Permission</th>
                <th style={thStyle}>State</th>
                <th style={thStyle}>Starts</th>
                <th style={thStyle}>Ends</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}></th>
              </tr>
            </thead>
            <tbody>
              {grants.map((g) => (
                <tr key={g.id}>
                  <td style={tdStyle}><Badge value={g.scope_type} /></td>
                  <td style={tdStyle}>{g.permission?.name || 'All (blanket)'}</td>
                  <td style={tdStyle}><Badge value={g.state} /></td>
                  <td style={tdStyle}>{g.starts_at ? new Date(g.starts_at).toLocaleString() : '—'}</td>
                  <td style={tdStyle}>{g.ends_at ? new Date(g.ends_at).toLocaleString() : '—'}</td>
                  <td style={tdStyle}><Badge value={g.status} /></td>
                  <td style={tdStyle}>
                    {g.status !== 'cancelled' && g.status !== 'expired' && (
                      <button style={btnDanger} onClick={() => cancel(g.id)}>Cancel</button>
                    )}
                  </td>
                </tr>
              ))}
              {grants.length === 0 && <tr><td style={tdStyle} colSpan={7}>No temporary grants found.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
